const PRODUCT_INFO_HEADINGS = new Map([
  ['key features', { open: true, specs: false }],
  ['product specifications', { open: false, specs: true }],
  ['package dimensions & weight', { open: false, specs: true }],
  ['box dimensions', { open: false, specs: true }],
]);

const FIT_REMINDER = 'Before ordering, please compare the packaged dimensions with your doorway, hallway, elevator and stair access.';

const normalizeHeading = (value = '') => value.trim().replace(/\s+/g, ' ').toLowerCase();

const enhanceSpecificationList = (container) => {
  const list = container.querySelector(':scope > ul');
  if (!list) return;

  list.classList.add('kaylulu-spec-list');
  list.querySelectorAll(':scope > li').forEach((item) => {
    const label = item.querySelector(':scope > strong');
    if (!label) return;

    const value = document.createElement('span');
    value.className = 'kaylulu-spec-value';
    while (label.nextSibling) value.append(label.nextSibling);
    item.append(value);
  });
};

const addFitReminder = (formatter) => {
  if (formatter.querySelector('.kaylulu-fit-reminder')) return;

  const heading = [...formatter.children].find((element) => {
    if (!/^H[2-4]$/.test(element.tagName)) return false;
    const normalized = normalizeHeading(element.textContent);
    return normalized === 'package dimensions & weight' || normalized === 'box dimensions';
  });
  if (!heading) return;

  let insertionPoint = heading;
  let sibling = heading.nextElementSibling;
  while (sibling && !/^H[2-4]$/.test(sibling.tagName)) {
    insertionPoint = sibling;
    sibling = sibling.nextElementSibling;
  }

  const reminder = document.createElement('p');
  reminder.className = 'kaylulu-fit-reminder';
  reminder.textContent = FIT_REMINDER;
  insertionPoint.insertAdjacentElement('afterend', reminder);
};

const enhanceProductInformation = () => {
  document.querySelectorAll('.product-details rte-formatter.rte').forEach((formatter) => {
    addFitReminder(formatter);
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    if (formatter.dataset.kayluluAccordion === 'true') return;

    const headings = [...formatter.children].filter((element) => {
      if (!/^H[2-4]$/.test(element.tagName)) return false;
      return PRODUCT_INFO_HEADINGS.has(normalizeHeading(element.textContent));
    });
    if (!headings.length) return;

    formatter.dataset.kayluluAccordion = 'true';
    formatter.classList.add('kaylulu-product-info');

    headings.forEach((heading) => {
      const configuration = PRODUCT_INFO_HEADINGS.get(normalizeHeading(heading.textContent));
      const details = document.createElement('details');
      details.className = 'kaylulu-product-accordion';
      details.open = configuration.open;

      const summary = document.createElement('summary');
      const title = document.createElement('span');
      title.textContent = heading.textContent.trim();
      const icon = document.createElement('span');
      icon.className = 'kaylulu-product-accordion__icon';
      icon.setAttribute('aria-hidden', 'true');
      summary.append(title, icon);

      const content = document.createElement('div');
      content.className = 'kaylulu-product-accordion__content';

      let sibling = heading.nextSibling;
      while (sibling) {
        const next = sibling.nextSibling;
        if (sibling.nodeType === Node.ELEMENT_NODE && /^H[2-4]$/.test(sibling.tagName) && PRODUCT_INFO_HEADINGS.has(normalizeHeading(sibling.textContent))) break;
        content.append(sibling);
        sibling = next;
      }

      if (configuration.specs) enhanceSpecificationList(content);
      details.append(summary, content);
      heading.replaceWith(details);
    });
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', enhanceProductInformation, { once: true });
} else {
  enhanceProductInformation();
}

document.addEventListener('shopify:section:load', enhanceProductInformation);
